// src/layout/MainLayout.js
import React from 'react';
import 'devextreme/dist/css/dx.light.css';
import '../styles/tailwind.css';
import Sidebar from '../component/Sidebar';
import Header from '../component/Header';

const MainLayout = ({ children, pageTitle }) => {
  return (
    // Container artık tam ekran yüksekliğini (h-screen) kaplıyor
    // overflow-hidden, sağ tarafta kaydırma çubuğunun sadece main içinde kalmasını sağlar
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar sol tarafta her zaman tam yükseklikte */}
      <Sidebar />

      {/* Sağdaki alan: Header + içerik */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Header sabit yüksekliğiyle en üstte */}
        <Header pageTitle={pageTitle} />

        {/* İçerik kısmı, Header altındaki boşluğu doldurup dikey kaydırma sunar */}
        <main className="flex-1 p-4 bg-gray-50 dark:bg-gray-900 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
